/**
 * cn() — class-name merge utility for Tailwind.
 *
 * Wraps clsx (conditional join) + tailwind-merge (last-value-wins for conflicting Tailwind classes).
 * Required because string-template concatenation alone cannot resolve Tailwind class conflicts —
 * `cn('w-full', 'w-[500px]')` correctly emits `w-[500px]`, while `` `${a} ${b}` `` would emit both
 * and let class order in the generated CSS decide.
 *
 * Use this in every primitive / component under `src/design-system/`. Existing files outside
 * the design-system folder migrate to `cn()` as they are touched.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export default cn;
